import React, { Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "./context/LanguageContext";
import { Toaster } from "./components/ui/sonner";
import ScrollToTop from "./components/ScrollToTop";
import ErrorBoundary from "./components/ErrorBoundary";

import HomePage from "./pages/HomePage";

const SobrePage          = React.lazy(() => import("./pages/SobrePage"));
const ServicosPage       = React.lazy(() => import("./pages/ServicosPage"));
const ServicoDetailPage  = React.lazy(() => import("./pages/ServicoDetailPage"));
const CursosPage         = React.lazy(() => import("./pages/CursosPage"));
const ParceirosPage      = React.lazy(() => import("./pages/ParceirosPage"));
const EventosPage        = React.lazy(() => import("./pages/EventosPage"));
const BlogListPage       = React.lazy(() => import("./pages/BlogPage").then(m => ({ default: m.BlogListPage })));
const BlogPostPage       = React.lazy(() => import("./pages/BlogPage").then(m => ({ default: m.BlogPostPage })));
const AuthorProfilePage  = React.lazy(() => import("./pages/AuthorProfilePage"));
const ContatoPage        = React.lazy(() => import("./pages/ContatoPage"));
const AssociacaoPage     = React.lazy(() => import("./pages/AssociacaoPage"));
const OportunidadesPage      = React.lazy(() => import("./pages/OportunidadesPage"));
const OportunidadeDetailPage = React.lazy(() => import("./pages/OportunidadeDetailPage"));
const AdminDashboard         = React.lazy(() => import("./pages/AdminDashboard"));
const BlogEditorPage     = React.lazy(() => import("./pages/BlogEditorPage"));
const MemberPortal       = React.lazy(() => import("./pages/MemberPortal"));
const ManagerDashboard   = React.lazy(() => import("./pages/ManagerDashboard"));
const ManagerBlogEditorPage = React.lazy(() => import("./pages/ManagerBlogEditorPage"));

const PageFallback = () => (
  <div className="min-h-screen flex items-center justify-center" style={{ background: '#1A1F4B' }}>
    <div className="w-10 h-10 border-4 border-[#C9A84C] border-t-transparent rounded-full animate-spin" />
  </div>
);

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <div className="App">
          <BrowserRouter>
            <ScrollToTop />
            <ErrorBoundary>
              <Suspense fallback={<PageFallback />}>
                <Routes>
                  <Route path="/"               element={<HomePage />} />
                  <Route path="/sobre"          element={<SobrePage />} />
                  <Route path="/servicos"       element={<ServicosPage />} />
                  <Route path="/servicos/:slug" element={<ServicoDetailPage />} />
                  <Route path="/cursos"         element={<CursosPage />} />
                  <Route path="/parceiros"      element={<ParceirosPage />} />
                  <Route path="/oportunidades"       element={<OportunidadesPage />} />
                  <Route path="/oportunidades/:slug" element={<OportunidadeDetailPage />} />
                  <Route path="/eventos"        element={<EventosPage />} />
                  <Route path="/blog"           element={<BlogListPage />} />
                  <Route path="/blog/:slug"     element={<BlogPostPage />} />
                  <Route path="/autores/:slug"  element={<AuthorProfilePage />} />
                  <Route path="/contato"        element={<ContatoPage />} />
                  <Route path="/associacao"     element={<AssociacaoPage />} />
                  <Route path="/admin"                   element={<AdminDashboard />} />
                  <Route path="/admin/blog/new"          element={<BlogEditorPage />} />
                  <Route path="/admin/blog/:id/edit"     element={<BlogEditorPage />} />
                  <Route path="/member"                  element={<MemberPortal />} />
                  <Route path="/manager"                 element={<ManagerDashboard />} />
                  <Route path="/manager/blog/new"        element={<ManagerBlogEditorPage />} />
                  <Route path="/manager/blog/:id/edit"   element={<ManagerBlogEditorPage />} />
                </Routes>
              </Suspense>
            </ErrorBoundary>
          </BrowserRouter>
          <Toaster />
        </div>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
